import { Formik } from "formik";
import Loader from "../../loader";
import ErrorMessage from "../../form/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import { hireTalentCompanyDetailSchema } from "../../../utils/schema";
import { addCompanyDetails } from "../../../redux/features/hire-talent/actions/authAction";
import { setIsHireTalentModal } from "../../../redux/features/hire-talent/reducers/authReducer";
import { useNavigate } from "react-router-dom";
import { hireTalentPaths } from "../../../routes/hire-talent";

const CompanyDetails = ({ backToLogin, onClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { subLoading } = useSelector((state) => state.hireTalent?.auth);

  const savedData = {
    company_name: "",
    company_website: "",
    number_of_employees: "",
    company_bio: "",
  };

  const handleSignup = (values) => {
    const payload = Object.fromEntries(
      Object.entries(values).map(([key, value]) => [
        key,
        typeof value === "string" ? value.trim() : value,
      ])
    );
    const callback = (res) => {
      if (res?.success) {
        dispatch(setIsHireTalentModal(false));
        onClose();
        navigate(hireTalentPaths?.Dashboard);
      }
    };

    dispatch(addCompanyDetails({ payload, callback }));
  };

  if (subLoading) {
    return <Loader />;
  }
  return (
    <div class="modal-body pe-0">
      <section class="ct_signup_main py-3">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-xxl-4 col-xl-4 col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
              <div class="ct_signup_left_img">
                <img
                  src="../assets/img/company_details.png"
                  alt=""
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div class="col-xxl-8 col-xl-8 col-lg-8 mb-4 mb-lg-0 ">
              <div class="ct_signup_right_content px-5 ct_custom_scroll">
                <div class="ct_signup_logo ct_mb_34">
                  <img src="../assets/img/Nuvio_logo.png" alt="" />
                </div>
                <div class="mt-0 text-center">
                  <h2 class="ct_fs_32  mb-0">
                    Welcome to <span class="ct_yellow_text">Nuvio</span>
                  </h2>
                </div>
                <Formik
                  initialValues={savedData}
                  validationSchema={hireTalentCompanyDetailSchema}
                  onSubmit={(values, actions) => {
                    handleSignup(values);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                  }) => (
                    <form class="mt-5">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group mb-4">
                            <label
                              for=""
                              class="mb-2 d-block ct_fs_14 ct_darkblue_text"
                            >
                              Number of Employees
                            </label>
                            <input
                              type="text"
                              class="form-control ct_input"
                              placeholder="Number of Employees"
                              id="number_of_employees"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.number_of_employees}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="number_of_employees"
                            />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group mb-4">
                            <label
                              for=""
                              class="mb-2 d-block ct_fs_14 ct_darkblue_text"
                            >
                              Company Name
                            </label>
                            <input
                              type="text"
                              class="form-control ct_input"
                              placeholder="Company Name"
                              id="company_name"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.company_name}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="company_name"
                            />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group mb-4">
                            <label
                              for=""
                              class="mb-2 d-block ct_fs_14 ct_darkblue_text"
                            >
                              Company About
                            </label>
                            <textarea
                              type="text"
                              rows="3"
                              className="form-control ct_input h-auto"
                              placeholder="Company About"
                              id="company_bio"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.company_bio}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="company_bio"
                            />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group mb-4">
                            <label
                              for=""
                              class="mb-2 d-block ct_fs_14 ct_darkblue_text"
                            >
                              Company Website
                            </label>
                            <input
                              type="text"
                              class="form-control ct_input"
                              placeholder="Company Website"
                              id="company_website"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.company_website}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="company_website"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="text-center mt-2">
                        <button
                          type="submit"
                          onClick={handleSubmit}
                          class="ct_yellow_btn  w-100 mx-auto"
                        >
                          Continue{" "}
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
                <div class=" text-center mt-4 ct_darkblue_text">
                  Already have an account?{" "}
                  <a class="ct_orange_text" onClick={backToLogin}>
                    Sign In
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CompanyDetails;
